import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { SESSION_STORAGE, StorageService } from 'ngx-webstorage-service';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { ApiService } from '../../../api.service';

@Component({
  selector: 'app-portfilo-buckets',
  templateUrl: './portfilo-buckets.component.html',
  styleUrls: ['./portfilo-buckets.component.css']
})
export class PortfiloBucketsComponent implements OnInit {
  rows = [];
  final_row = [];
  searchQR: any;
  value1: any;
  final_data: any;
  original_portfolio_list: any;
  origianl_bank_list: any;

  portfolio_list: any;
  booleans: boolean;
  login_Details: any;
  Internal_Allocate_show: boolean;
  constructor(
    private router: Router,
    private _api: ApiService,
    @Inject(SESSION_STORAGE) private storage: StorageService,
    private http: HttpClient,
  ) { }

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.login_Details = this.getFromLocal("login_Details");
    console.log(this.login_Details)




    for (let a = 0; a < this.login_Details.access.length; a++) {
      if (this.login_Details.access[a].title == 'Internal Allocate' && this.login_Details.access[a].Status == true) {
        this.Internal_Allocate_show = true;
      }

    }
    this.saveInLocal('Entity_data', undefined);
    this.bank_list_get();
    this.portfolio_list_get();

    let a = {
      assigned_to: this.getFromLocal("User_ID"),
      client_id: this.getFromLocal("Client_ID")
    }
    this._api.fetch_data_using_allocated_list(a).subscribe(
      (response: any) => {
        let rows = response.Data.reverse();
        this.final_data = [];
        this.final_data = rows;
        // let start  = '2022-01-01T00:00:00.000Z';
        // let end = '2022-01-31T00:00:00.000Z';
        // rows.forEach((element, index) => {
        //   var from = new Date(start);  // -1 because months are from 0 to 11
        //   var to   = new Date(end);
        //   var check = new Date(element.createdAt);
        //   let checks = (check >= from && check <= to);
        //   if(checks == true){
        //     this.final_data.push(element);
        //   }
        // });


        const group = (data) =>
      
          data.reduce((acc, { bucket_id, client_id, bank_id, date_of_allocations, porfolio_id }) => {
            const item = acc.find((el) => el.bucket_id === bucket_id);


            if (item) item.client_id += client_id;

            else acc.push({ bucket_id, client_id, bank_id, date_of_allocations, porfolio_id });
            return acc;
          }, []);
        this.final_data = group(this.final_data);
        console.log("3424", this.final_data);
        this.final_data.sort((a, b) => new Date(b.date_of_allocations).getTime() - new Date(a.date_of_allocations).getTime());
      }
    );

  }



  client_form() {
    // this.saveInLocal('Client_form', 'client');
    this.router.navigateByUrl('admin_panel/Super_admin/EntityForm')
  }
  profile() {
    this.router.navigateByUrl('/admin_panel/Client_profile')
  }
  saveInLocal(key, val): void {
    this.storage.set(key, val);
  }

  getFromLocal(key): any {
    return this.storage.get(key);
  }
  client_form_view(item) {
    this.saveInLocal('Entity_data', item);
    this.router.navigateByUrl('admin_panel/Super_admin/EntityForm')
  }
  Delete(id) {
    let a = {
      "_id": id
    }
    this._api.entity_delete(a).subscribe(
      (response: any) => {
        if (response.Code == 200) {
          alert("Deleted successfully");
          this.ngOnInit();
        }
        else {
          alert('Somthing went wrong');
        }

      }
    );
  }


  move_to_select(item) {
    this.saveInLocal('portfolio_bucket_id', item);
    this.router.navigateByUrl('/admin_panel/portfilo_recordlist');
  }


  internal_allocation() {
    this.router.navigateByUrl('/admin_panel/worklist_buckets');
  }


  portfolio_list_get() {
    let a = {
      client_id: this.getFromLocal("Client_ID")
    }
    this._api.portfolio_type_list(a).subscribe(
      (response: any) => {
        this.original_portfolio_list = response.Data;
        // let list = response.Data.reverse();
        // for (let i = 0; i < list.length; i++) {
        //   let obj = { "y": list[i].portfolio_type};
        //   this.portfolio_list.push(obj);
        // }
        // this.booleans = true;
      }
    );
  }


  bank_list_get() {
    let a = {
      client_id: this.getFromLocal("Client_ID")
    }
    this._api.fetch_bank_list_by_client_id(a).subscribe(
      (response: any) => {
        this.origianl_bank_list = response.Data;
        // let list = response.Data.reverse();
        // for (let i = 0; i < list.length; i++) {
        //   let obj = { "y": list[i].portfolio_type};
        //   this.portfolio_list.push(obj);
        // }
        // this.booleans = true;
      }
    );
  }

}
